/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from 'owa-viewstate-store';
import { createStore } from 'owa-satcheljs';

import type { Location } from 'owa-graph-schema';

import type { OwaDate } from 'owa-datetime';
const dest = createAccessors(
    'hybridspace-user-settings',
    createStore('hybridspace-user-settings', {
        occurringFWH: new Array<{
            date: OwaDate;
            workLocation: string;
            workLocationDetails?: Location[];
        }>(),
        recurringFWH: new Array<{
            date: OwaDate;
            workLocation: string;
            workLocationDetails?: Location[];
        }>(),
    })
);
const setOccurringFWH: (
    newValue: {
        date: OwaDate;
        workLocation: string;
        workLocationDetails?: Location[];
    }[]
) => void = dest.setOccurringFWH;
const getOccurringFWH: () => {
    date: OwaDate;
    workLocation: string;
    workLocationDetails?: Location[];
}[] = dest.getOccurringFWH;
const setRecurringFWH: (
    newValue: {
        date: OwaDate;
        workLocation: string;
        workLocationDetails?: Location[];
    }[]
) => void = dest.setRecurringFWH;
const getRecurringFWH: () => {
    date: OwaDate;
    workLocation: string;
    workLocationDetails?: Location[];
}[] = dest.getRecurringFWH;

export { setOccurringFWH, getOccurringFWH, setRecurringFWH, getRecurringFWH };
